import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScreenshotsIcon',
  setup(__props) {

const attrs = iconAttributes({ width: 32, height: 32 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.66667 28C5.93333 28 5.30578 27.7391 4.784 27.2173C4.26222 26.6956 4.00089 26.0676 4 25.3333V6.66667C4 5.93333 4.26133 5.30578 4.784 4.784C5.30667 4.26222 5.93422 4.00089 6.66667 4H25.3333C26.0667 4 26.6947 4.26133 27.2173 4.784C27.74 5.30667 28.0009 5.93422 28 6.66667V25.3333C28 26.0667 27.7391 26.6947 27.2173 27.2173C26.6956 27.74 26.0676 28.0009 25.3333 28H6.66667Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27.2173 4.784C27.74 5.30667 28.0009 5.93422 28 6.66667V25.3333C28 26.0667 27.7391 26.6947 27.2173 27.2173C26.6956 27.74 26.0676 28.0009 25.3333 28H6.66667C5.93333 28 5.30578 27.7391 4.784 27.2173C4.26222 26.6956 4.00089 26.0676 4 25.3333V6.66667C4 5.93333 4.26133 5.30578 4.784 4.784C5.30667 4.26222 5.93422 4.00089 6.66667 4H25.3333C26.0667 4 26.6947 4.26133 27.2173 4.784ZM6.19821 25.8031C6.04903 25.6539 6.00039 25.5329 6 25.3318V6.66667C6 6.46858 6.04715 6.34902 6.19701 6.19942C6.34856 6.04812 6.4702 6.00038 6.66819 6H25.3333C25.5315 6 25.6522 6.04727 25.8031 6.19821C25.954 6.34909 26.0002 6.46852 26 6.66424V6.66667V25.3333C26 25.5326 25.9523 25.6536 25.8019 25.8043C25.6534 25.9531 25.5346 26.0002 25.3358 26H25.3333H6.66667C6.46747 26 6.34755 25.9525 6.19821 25.8031Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9 21.8346H23L18.625 16.0013L15.125 20.668L12.5 17.168L9 21.8346ZM11.9167 13.668C12.4028 13.668 12.816 13.4978 13.1562 13.1576C13.4965 12.8173 13.6667 12.4041 13.6667 11.918C13.6667 11.4319 13.4965 11.0187 13.1562 10.6784C12.816 10.3381 12.4028 10.168 11.9167 10.168C11.4306 10.168 11.0174 10.3381 10.6771 10.6784C10.3368 11.0187 10.1667 11.4319 10.1667 11.918C10.1667 12.4041 10.3368 12.8173 10.6771 13.1576C11.0174 13.4978 11.4306 13.668 11.9167 13.668Z",
      fill: "currentColor"
    }, null, -1)
  ]), 16))
}
}

})